import {singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {Issue} from "../../domain/entities/issue.entity";
import {FinalizeIssueCommand} from "../finalize-issue.command";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";

@CommandHandler(FinalizeIssueCommand)
@singleton()
export class FinalizeIssueCommandHandler implements ICommandHandler<Issue> {

    public handle(command: ICommand<Issue>): void {
        // Command handling logic would go here
    }

}